import { render, staticRenderFns } from "./PurchaseReportFiling.vue?vue&type=template&id=9b48db70&"
import script from "./PurchaseReportFiling.vue?vue&type=script&lang=js&"
export * from "./PurchaseReportFiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports